
import React, { useState } from 'react';

const Connect4: React.FC = () => {
  const [grid, setGrid] = useState<string[][]>(Array(6).fill(null).map(() => Array(7).fill('')));
  const [isRedNext, setIsRedNext] = useState(true);

  const drop = (c: number) => {
    const newGrid = [...grid.map(r => [...r])];
    for (let r = 5; r >= 0; r--) {
      if (!newGrid[r][c]) {
        newGrid[r][c] = isRedNext ? 'R' : 'B';
        setGrid(newGrid);
        setIsRedNext(!isRedNext);
        return;
      }
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div className="mb-6 text-xl font-bold flex items-center gap-2">
        <div className={`w-4 h-4 rounded-full ${isRedNext ? 'bg-red-500' : 'bg-blue-600'}`} />
        {isRedNext ? "RED'S TURN" : "BLUE'S TURN"}
      </div>
      <div className="bg-slate-800 p-4 rounded-xl grid grid-cols-7 gap-2">
        {Array(7).fill(0).map((_, c) => (
          <div key={c} className="flex flex-col gap-2">
            <button onClick={() => drop(c)} className="w-10 h-10 rounded-full bg-slate-700 hover:bg-slate-600 mb-2" />
            {grid.map((row, r) => (
              <div key={r} className={`w-10 h-10 rounded-full ${row[c] === 'R' ? 'bg-red-500' : row[c] === 'B' ? 'bg-blue-600' : 'bg-slate-900'}`} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Connect4;
